import React, { useEffect, useState } from 'react';
import * as Icon from 'react-bootstrap-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { useTranslation } from '../../../common/hooks/useTranslation';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNotifications } from '../../../common/hooks/useNotifications';
import Button from '../../../common/components/Button/Button';

import { SalesInvoicePaymentsModal } from './SalesInvoicePaymentsModal';

interface SalesInvoicePaymentsButtonProps {
  invoiceNumber: string;
  invoiceDate?: Date;
  showLabel?: boolean;
  active?: boolean;
}

export const SalesInvoicePaymentsButton: React.FC<
  SalesInvoicePaymentsButtonProps
> = props => {
  const [show, setShow] = useState(false);
  const [symphonyHandel, setSymphonyHandel] = useState<boolean | undefined>();
  const { t, tk } = useTranslation('fvsLng');
  const pok = usePokCore();
  const notifications = useNotifications();

  useEffect(() => {
    pok.companies
      .getById(pok.getCompanyId())
      .then(company => setSymphonyHandel(company?.symphonyHandel ?? false))
      .catch(err => notifications.caughtError(err));
  }, [pok, notifications]);

  const envEnabled =
    process.env.REACT_APP_SALES_INVOICES_WITH_PAYMENTS?.toLocaleLowerCase() ===
    'on';

  if (!envEnabled || !symphonyHandel) {
    return null;
  }

  if (props.active === false) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShow(true);
  };

  return (
    <>
      {props.showLabel ? (
        <Button variant="outline-secondary" onClick={handleClick}>
          <Icon.Wallet2 size={16} className="me-2" />
          {t(tk.finance.paymentsList)}
        </Button>
      ) : (
        <OverlayTrigger
          overlay={<Tooltip>{t(tk.finance.paymentsList)}</Tooltip>}
        >
          <Icon.Wallet2
            size={16}
            style={{ cursor: 'pointer' }}
            className="icon-blue"
            onClick={handleClick}
          />
        </OverlayTrigger>
      )}
      <SalesInvoicePaymentsModal
        invoiceNumber={props.invoiceNumber}
        invoiceDate={props.invoiceDate}
        show={show}
        onClose={() => setShow(false)}
      />
    </>
  );
};
